<template>
  <v-card class="px-2 py-2" flat tile>
    <template v-if="mode !== 'list'">
      <devContainerOfPanel
        :schema="{
          type: 'devContainerOfPanel',
          model: 'attributesLayout',
          component: 'dev-attr-crud-vuetify',
          styleClasses: 'col-12',
          title: 'Attributes Layout'
        }"
        :model="{ attributesLayout: schema[mode].attributes.attributesLayout }"
      />

      <devContainerOfPanel
        v-if="mode === 'sidebar'"
        class="mt-2"
        :schema="{
          type: 'devContainerOfPanel',
          model: 'attributesNavigationDrawer',
          component: 'dev-attr-crud-vuetify',
          styleClasses: 'col-12',
          title: 'attributesNavigationDrawer'
        }"
        :model="{ attributesNavigationDrawer: schema[mode].attributes.attributesNavigationDrawer }"
      />
    </template>

    <template v-if="mode === 'list'">
      <v-row no-gutters>
        <v-col cols="6">
          <v-switch v-model="schema[mode].attributes.actionsToolbar" label="actionsToolbar" dense hide-details class="mb-4" color="grey darken-3" />
        </v-col>

        <v-col cols="6">
          <v-switch v-model="schema[mode].executeInLoad" label="executeInLoad" dense hide-details class="mb-4" color="grey darken-3" />
        </v-col>

        <v-col cols="12">
          <v-select
            :items="displayModes"
            v-model="schema[mode].display"
            label="display"
            class="mb-4"
            append-icon="zmdi zmdi-chevron-down"
            color="grey darken-3"
            dense
            hide-details
          />
        </v-col>

        <v-col cols="12">
          <v-select
            :items="displayDialogs"
            v-model="schema[mode].dialog"
            label="dialog"
            class="mb-4"
            append-icon="zmdi zmdi-chevron-down"
            color="grey darken-3"
            dense
            hide-details
          />
        </v-col>

        <v-col cols="6">
          <v-select
            :items="['page', 'dialog', 'below', 'sidebar']"
            v-model="schema[mode].targetList"
            label="targetList"
            hide-details
            dense
            class="mr-1"
            color="grey darken-3"
            append-icon="zmdi zmdi-chevron-down"
          />
        </v-col>

        <v-col cols="6" v-if="activeAttributesDataIterator">
          <v-select
            :items="['page', 'dialog', 'below', 'sidebar']"
            v-model="schema[mode].targetCard"
            label="targetCard"
            hide-details
            dense
            class="ml-1"
            color="grey darken-3"
            append-icon="zmdi zmdi-chevron-down"
          />
        </v-col>
      </v-row>

      <devContainerOfPanel
        :schema="{
          type: 'devContainerOfPanel',
          model: 'attributesLayoutList',
          component: 'dev-attr-crud-vuetify',
          styleClasses: 'col-12',
          title: 'Attributes Layout'
        }"
        :model="{ attributesLayoutList: schema[mode].attributes.attributesLayout }"
        class="mb-2 mt-4"
      />

      <v-row no-gutters>
        <v-col cols="12">
          <v-switch
            v-model="activeAttributesTable"
            label="Attributes Table"
            dense
            hide-details
            class="my-2"
            color="grey darken-3"
            @change="toggleActiveAttributesTable"
          />
        </v-col>
      </v-row>

      <template v-if="activeAttributesTable">
        <v-row no-gutters class="mb-2">
          <v-col cols="6">
            <v-text-field
              v-model="schema[mode].attributes.attributesTable.keyValue"
              label="keyValue"
              class="mr-1 mt-2"
              dense
              hide-details
              color="grey darken-3"
            />
          </v-col>

          <v-col cols="6">
            <v-switch
              v-model="schema[mode].attributes.attributesTable.showSearch"
              label="showSearch"
              class="ml-1 mt-3"
              dense
              hide-details
              color="grey darken-3"
              @change="reloadComponent"
            />
          </v-col>

          <v-col cols="6">
            <v-text-field
              v-model="schema[mode].attributes.attributesTable.editIcon"
              label="editIcon"
              class="mr-1 mt-2 mb-2"
              hide-details
              color="grey darken-3"
            />
          </v-col>

          <v-col cols="6" v-if="modes.filter(mode => mode !== 'list').length">
            <v-select
              :items="modes.filter(mode => mode !== 'list')"
              v-model="schema[mode].attributes.attributesTable.editMode"
              label="editMode"
              class="ml-1 mt-2 mb-2"
              color="grey darken-3"
              hide-details
              append-icon="zmdi zmdi-chevron-down"
            />
          </v-col>
        </v-row>

        <devContainerOfPanel
          :schema="{
            type: 'devContainerOfPanel',
            model: 'attributesTable',
            component: 'dev-attr-crud-vuetify',
            styleClasses: 'col-12',
            title: 'Attributes Table'
          }"
          :model="{ attributesTable: schema[mode].attributes.attributesTable.dataTable }"
          class="mb-2"
        />

        <devContainerOfPanel
          :schema="{
            type: 'devContainerOfPanel',
            model: 'itemsPerPageOptions',
            component: 'dev-array-objects-attr',
            styleClasses: 'col-12',
            title: 'itemsPerPageOptions',
            objectRequired: ['text', 'value']
          }"
          :model="{ itemsPerPageOptions: schema[mode].attributes.attributesTable.itemsPerPageOptions }"
          class="mb-2"
        />
      </template>

      <v-row no-gutters>
        <v-col cols="12">
          <v-switch
            v-model="activeAttributesDataIterator"
            label="Attributes DataIterator"
            dense
            hide-details
            class="mt-2"
            @change="toggleActiveAttributesDataIterator"
            color="grey darken-3"
          />
        </v-col>
      </v-row>

      <template v-if="activeAttributesDataIterator">
        <v-row no-gutters class="mb-4">
          <v-col cols="6">
            <v-text-field
              v-model="schema[mode].attributes.attributesDataIterator.keyValue"
              label="keyValue"
              class="mr-1 mb-1"
              color="grey darken-3"
              hide-details
            />
          </v-col>

          <v-col cols="6" v-if="modes.filter(mode => mode !== 'list').length">
            <v-select
              :items="modes.filter(mode => mode !== 'list')"
              v-model="schema[mode].attributes.attributesDataIterator.editMode"
              label="editMode"
              class="ml-1 mb-1"
              color="grey darken-3"
              append-icon="zmdi zmdi-chevron-down"
              hide-details
            />
          </v-col>

          <v-col cols="6">
            <v-text-field
              v-model="schema[mode].attributes.attributesDataIterator.itemsPerPage"
              label="itemsPerPage"
              class="mr-1 mt-4"
              color="grey darken-3"
              dense
              hide-details
            />
          </v-col>
        </v-row>

        <v-expansion-panels class="accordion-list-components mb-2" hover focusable>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <span class="text-subtitle-2 font-weight-medium grey--text text--darken-3">dataIteratorComponents</span>
            </v-expansion-panel-header>

            <v-expansion-panel-content>
              <v-card class="px-2 py-2" flat tile>
                <v-card class="d-flex justify-end mt-0 mb-2" flat tile>
                  <v-btn small class="px-2 white--text" color="grey darken-3" @click="handleAddDataAttrComponent">
                    Adicionar
                    <v-icon class="ml-2" small>add</v-icon>
                  </v-btn>
                </v-card>

                <template v-if="schema[mode].attributes.attributesDataIterator.dataIteratorComponents.length">
                  <v-expansion-panels
                    v-for="(item, index) in schema[mode].attributes.attributesDataIterator.dataIteratorComponents"
                    class="accordion-list-components mb-2"
                    hover
                    focusable
                    :key="index"
                  >
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <span class="text-subtitle-2 font-weight-medium grey--text text--darken-3">{{ item.label }}</span>
                      </v-expansion-panel-header>

                      <v-expansion-panel-content v-if="dataIteratorComponentsReload">
                        <v-row no-gutters class="px-2 py-2">
                          <v-col cols="12">
                            <v-card class="d-flex justify-space-between align-start" flat tile>
                              <v-checkbox
                                v-model="item.default"
                                label="Default"
                                @change="toggleDefaultDataAttrComponent($event, index)"
                                hide-details
                                class="mt-0"
                                color="grey darken-3"
                              />

                              <v-icon color="red" class="mr-0 mt-0" small @click="handleRemoveDataAttrComponent(index)">delete</v-icon>
                            </v-card>
                          </v-col>

                          <v-col cols="6">
                            <v-text-field v-model="item.label" label="Label" class="mr-1 mt-5 mb-2" color="grey darken-3" dense hide-details />
                          </v-col>

                          <v-col cols="6">
                            <v-text-field v-model="item.icon" label="Icon" class="ml-1 mt-5 mb-2" color="grey darken-3" dense hide-details />
                          </v-col>

                          <v-col cols="12">
                            <v-text-field
                              v-model="item.component.name"
                              label="Component"
                              class="mt-3 mb-2"
                              color="grey darken-3"
                              dense
                              hide-details
                            />
                          </v-col>

                          <template v-if="item.component.name === 'field-i4pro-card-news-ecm'">
                            <p class="caption font-weight-medium pt-2">Card News attributes:</p>

                            <v-col cols="12">
                              <v-select
                                :items="['text', 'hover']"
                                v-model="item.component.attributes.layout"
                                label="layout"
                                class="mb-4"
                                append-icon="zmdi zmdi-chevron-down"
                                color="grey darken-3"
                                dense
                                hide-details
                              />
                            </v-col>

                            <v-col cols="12">
                              <v-checkbox v-model="item.component.attributes.title" label="Title" hide-details class="mt-0" color="grey darken-3" />
                            </v-col>

                            <v-col cols="12" v-if="item.component.attributes.title">
                              <v-text-field
                                v-model="item.component.attributes.titleStyleClasses"
                                label="titleStyleClasses"
                                class="mt-4 mb-2"
                                color="grey darken-3"
                                dense
                                hide-details
                              />
                            </v-col>

                            <v-col cols="12">
                              <v-checkbox
                                v-model="item.component.attributes.description"
                                label="Description"
                                hide-details
                                class="mt-0"
                                color="grey darken-3"
                              />
                            </v-col>

                            <v-col cols="12" v-if="item.component.attributes.description">
                              <v-text-field
                                v-model="item.component.attributes.descriptionStyleClasses"
                                label="descriptionStyleClasses"
                                class="mt-4 mb-2"
                                color="grey darken-3"
                                dense
                                hide-details
                              />
                            </v-col>

                            <v-col cols="6" v-if="item.component.attributes.description">
                              <v-text-field
                                v-model="item.component.attributes.descriptionMaxLenght"
                                type="number"
                                label="descriptionMaxLenght"
                                class="mt-4 mb-2"
                                color="grey darken-3"
                                dense
                                hide-details
                              />
                            </v-col>
                          </template>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </template>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <devContainerOfPanel
          :schema="{
            type: 'devContainerOfPanel',
            model: 'itemsPerPageOptions',
            component: 'dev-array-objects-attr',
            styleClasses: 'col-12',
            title: 'itemsPerPageOptions',
            objectRequired: ['text', 'value'],
            orderBy: true
          }"
          :model="{ itemsPerPageOptions: schema[mode].attributes.attributesDataIterator.itemsPerPageOptions }"
          class="mb-2"
        />

        <devContainerOfPanel
          :schema="{
            type: 'devContainerOfPanel',
            model: 'breakpoints',
            component: 'dev-simple-object-attr',
            styleClasses: 'col-12',
            title: 'Breakpoints'
          }"
          :model="{ breakpoints: schema[mode].attributes.attributesDataIterator.breakpoints }"
        />
      </template>
    </template>
  </v-card>
</template>

<script>
import eventBus from 'vue-option-events';
import * as HANDLERS from '@/helpers/types/handlers';

const attributesTable = {
  keyValue: '',
  showSearch: true,
  editIcon: 'edit',
  editMode: '',
  dataTable: {
    dense: true,
    showSelect: false,
    multiSort: false,
    showExpand: false,
    hideActions: false,
    hideDefaultFooter: false,
    externalPagination: true,
    sortBy: [],
    itemsPerPage: 10,
    loadingText: 'Carregando...',
    noDataText: 'Sem dados...',
    noResultsText: 'Sem resultados...',
    footerProps: {
      showFirstLastPage: true,
      firstIcon: 'fas fa-angle-double-left',
      lastIcon: 'fas fa-angle-double-right',
      prevIcon: 'keyboard_arrow_left',
      nextIcon: 'keyboard_arrow_right'
    },
    itemsPerPageOptions: [
      {
        text: '4',
        value: 4
      },
      {
        text: '16',
        value: 16
      },
      {
        text: '32',
        value: 32
      },
      {
        text: 'Todos',
        value: -1
      }
    ]
  }
};

const attributesDataIterator = {
  keyValue: '',
  editMode: '',
  itemsPerPage: 4,
  itemsPerPageOptions: [
    {
      text: '4',
      value: 4
    },
    {
      text: '16',
      value: 16
    },
    {
      text: '32',
      value: 32
    },
    {
      text: 'Todos',
      value: -1
    }
  ],
  breakpoints: {
    xs: 12,
    sm: 6,
    md: 3,
    lg: 3,
    xl: 2
  },
  dataIteratorComponents: [
    {
      default: true,
      label: 'List',
      icon: 'receipt',
      component: {
        name: 'field-i4pro-card-list',
        attributes: {}
      }
    }
  ]
};

export default {
  components: {
    devContainerOfPanel: () => import('@/components/dev/dev-container-of-panel')
  },

  data: () => ({
    activeAttributesTable: false,
    activeAttributesDataIterator: false,
    displayModes: ['list', 'grid'],
    dataIteratorComponentsReload: true,
    displayDialogs: []
  }),

  mounted() {
    if (this.mode === 'list' && 'attributesTable' in this.schema[this.mode].attributes) this.activeAttributesTable = true;

    if (this.mode === 'list' && 'attributesDataIterator' in this.schema[this.mode].attributes) this.activeAttributesDataIterator = true;

    if (
      this.mode === 'list' &&
      'attributesTable' in this.schema[this.mode].attributes &&
      !('itemsPerPageOptions' in this.schema[this.mode].attributes.attributesTable)
    ) {
      this.schema[this.mode].attributes.attributesTable.itemsPerPageOptions = [
        {
          text: '4',
          value: 4
        },
        {
          text: '8',
          value: 8
        },
        {
          text: '16',
          value: 16
        },
        {
          text: '32',
          value: 32
        },
        {
          text: '100',
          value: 100
        },
        {
          text: 'Todos',
          value: -1
        }
      ];
    }

    if (
      this.mode === 'list' &&
      'attributesDataIterator' in this.schema[this.mode].attributes &&
      !('itemsPerPageOptions' in this.schema[this.mode].attributes.attributesDataIterator)
    ) {
      this.schema[this.mode].attributes.attributesDataIterator.itemsPerPageOptions = [
        {
          text: '4',
          value: 4
        },
        {
          text: '8',
          value: 8
        },
        {
          text: '16',
          value: 16
        },
        {
          text: '32',
          value: 32
        },
        {
          text: '100',
          value: 100
        },
        {
          text: 'Todos',
          value: -1
        }
      ];
    }

    this.getNameDialogs(this.configLayout.dialogs);
  },

  props: {
    mode: { type: String, default: '', required: true },
    modes: { type: Array, default: () => [], required: true }
  },

  computed: {
    schema() {
      return this.$store.getters['dev/getSchema'];
    },

    configLayout() {
      return this.$store.getters['dev/getConfigLayout'];
    }
  },

  methods: {
    getNameDialogs(list) {
      if (!list) return;

      this.displayDialogs = Object.keys(list).map(item => {
        return item;
      });
    },

    reloadComponent() {
      eventBus.$emit(HANDLERS.RELOAD_COMPONENT_DEV);
    },

    toggleActiveAttributesTable(e) {
      if (!e) {
        this.schema[this.mode].display = 'grid';

        this.schema[this.mode].attributes.attributesDataIterator = attributesDataIterator;

        this.$nextTick(() => {
          this.activeAttributesDataIterator === false && (this.activeAttributesDataIterator = true);
        });

        delete this.schema[this.mode].attributes.attributesTable;
      } else {
        this.schema[this.mode].attributes.attributesTable = attributesTable;
      }

      this.reloadComponent();
    },

    toggleActiveAttributesDataIterator(e) {
      if (!e) {
        this.schema[this.mode].display = 'list';

        this.schema[this.mode].attributes.attributesTable = attributesTable;

        this.$nextTick(() => this.activeAttributesTable === false && (this.activeAttributesTable = true));

        delete this.schema[this.mode].attributes.attributesDataIterator;
      }

      if (e) this.schema[this.mode].attributes.attributesDataIterator = attributesDataIterator;

      this.reloadComponent();
    },

    toggleDefaultDataAttrComponent(e, index) {
      let isThereADefault = this.schema[this.mode].attributes.attributesDataIterator.dataIteratorComponents.find(item => item.default === true);

      this.schema[this.mode].attributes.attributesDataIterator.dataIteratorComponents.map((item, i) => {
        if (index !== i) item.default = false;
      });

      if (!isThereADefault) this.schema[this.mode].attributes.attributesDataIterator.dataIteratorComponents[0].default = true;

      this.dataIteratorComponentsReload = false;

      this.$nextTick(() => (this.dataIteratorComponentsReload = true));
    },

    handleAddDataAttrComponent() {
      const component = {
        default: false,
        label: 'Default',
        icon: '',
        component: {
          name: '',
          attributes: {}
        }
      };

      this.schema[this.mode].attributes.attributesDataIterator.dataIteratorComponents.push(JSON.parse(JSON.stringify(component)));

      this.dataIteratorComponentsReload = false;

      this.$nextTick(() => (this.dataIteratorComponentsReload = true));
    },

    handleRemoveDataAttrComponent(index) {
      this.schema[this.mode].attributes.attributesDataIterator.dataIteratorComponents.splice(index, 1);

      this.dataIteratorComponentsReload = false;

      this.$nextTick(() => (this.dataIteratorComponentsReload = true));
    }
  }
};
</script>
